import { css } from '@/styled-system/css';

export const propertyCardMenuTriggerStyles = css.raw({
  blockSize: 'PropertyCard.DataArea.buttonSlot.height',
  inlineSize: 'PropertyCard.DataArea.buttonSlot.width',
});
